import React from "react";
import {makeStyles} from "@mui/styles";
import clsx from 'clsx';
import Navbar from "./navbar/Navbar";
import MinimizedFooter from "./footer/MinimizedFooter";
import {atom, useRecoilValue} from "recoil";
import {Collapse} from "@mui/material";
import {Route, Switch} from "react-router-dom";
import Footer from "./footer/Footer";
import ScrollTopButton from "../ScrollTopButton/ScrollTopButton";

const useStyles = makeStyles((theme) => ({
    root: {
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
    },
    minHeight: {
        minHeight: "90vh"
    },
    content: {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
    },
    centered: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
}));

export const showNavigationState = atom({
    key: 'showNavigationState', // unique ID (with respect to other atoms/selectors)
    default: true // default value
});

export default function Layout({children}) {
    const classes = useStyles();
    const show = useRecoilValue(showNavigationState);

    return (
        <div className={classes.root}>
            <Collapse direction="up" in={show}>
                <><Navbar/></>
            </Collapse>
            <Switch>
                <Route path={["/page", "/profile", "/admin/*"]}>
                    <div className={clsx(classes.content, classes.centered)}>
                        {children}
                    </div>
                    <Collapse direction="up" in={show}>
                        <><MinimizedFooter/></>
                    </Collapse>
                </Route>
                <Route>
                    <div className={clsx(classes.content, classes.centered, classes.minHeight)}>
                        {children}
                    </div>
                    <Footer/>
                </Route>
            </Switch>
            <ScrollTopButton/>
        </div>
    );
}
